import { render, staticRenderFns } from "./InternetDetection.vue?vue&type=template&id=1ff9b47e&scoped=true"
import script from "./InternetDetection.vue?vue&type=script&lang=js"
export * from "./InternetDetection.vue?vue&type=script&lang=js"
import style0 from "./InternetDetection.vue?vue&type=style&index=0&id=1ff9b47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9b47e",
  null
  
)

export default component.exports